(function(){
  if(window.__advInit)return;
  window.__advInit=true;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('adv-in');io.unobserve(e.target)}})},{threshold:.12});
  function init(root){
    root.querySelectorAll('.adv-rv,.adv-frame').forEach(function(el){if(el.__adv)return;el.__adv=1;io.observe(el)});
    root.querySelectorAll('.adv-hero').forEach(function(h){requestAnimationFrame(function(){h.classList.add('adv-in')})});
    root.querySelectorAll('.adv-lineup').forEach(function(lu){
      var tg=lu.querySelector('.adv-toggle');
      if(!tg||tg.__adv)return;tg.__adv=1;
      tg.addEventListener('click',function(){
        var o=lu.classList.toggle('adv-open');
        tg.textContent=o?tg.getAttribute('data-hide'):tg.getAttribute('data-show');
        tg.setAttribute('aria-expanded',o);
      });
    });
  }
  function bar(){
    var b=document.querySelector('.adv-bar');if(!b)return;
    var hero=document.querySelector('.adv-hero'),buy=document.querySelector('.adv-buy');
    var past=hero?hero.getBoundingClientRect().bottom<0:true;
    var atBuy=buy?buy.getBoundingClientRect().top<innerHeight*.7:false;
    b.classList.toggle('adv-on',past&&!atBuy);
  }
  function start(){init(document);bar()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  addEventListener('scroll',bar,{passive:true});
  addEventListener('resize',bar);
  document.addEventListener('shopify:section:load',function(e){init(e.target);bar()});
})();